const Cookies = ({ globalContext }) =>
	typeof window === "undefined"
		? require("./server-side").default(globalContext)
		: require("./client-side").default();

export default Cookies;
